(() => {
  const initialize = (navMobile) => {
    const element = navMobile.element;
    const buttons = element.querySelectorAll('.nav-mobile__button');

    const toggleMenu = (event) => {
      const slug = event.target.dataset.slug;
      const navMenu = element.querySelector(`#${slug}`);

      if (!navMenu) {
        return false;
      }

      if (navMenu.classList.contains('mega-menu--active')) {
        return navMenu.classList.remove('mega-menu--active');
      }

      element.querySelectorAll('.mega-menu').forEach((menu) => menu.classList.remove('mega-menu--active'));

      return navMenu.classList.toggle('mega-menu--active');
    };

    buttons.forEach((button) => button.addEventListener('click', toggleMenu));
  };

  const nav = stp.setup('nav-mobile');
  nav.map(initialize);
})();
